"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var React = __importStar(require("react"));
var ErrorBoundary_1 = __importDefault(require("./ErrorBoundary"));
var Lister = /** @class */ (function (_super) {
    __extends(Lister, _super);
    function Lister(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            items: [],
            selected: [],
            page: null,
            lastPage: null,
            sorts: [],
            filters: [],
            defaultFilter: [],
            cache: null,
            search: _this.props.search,
            searchItem: '',
            searchFields: [],
            typingTimeout: 0,
            overallCount: 0
        };
        _this.resetState = function () {
            _this.setState({
                selected: [],
                page: 1,
                sorts: [],
                filters: [],
                searchItem: ''
            });
        };
        _this.navigateBackwards = function () {
            var page = _this.state.page - 1;
            _this.navigateToPage(page);
        };
        _this.navigateForwards = function () {
            var page = _this.state.page + 1;
            _this.navigateToPage(page);
        };
        _this.navigateToPage = function (page) {
            _this.setState({
                page: page < 1
                    ? 1
                    : _this.state.lastPage && page > _this.state.lastPage
                        ? _this.state.lastPage
                        : page
            });
        };
        _this.gotoPage = function (event) {
            _this.setState({
                page: Number(event.target.value)
            });
        };
        _this.addSort = function (sort) {
            var sortIndex = _this.state.sorts.findIndex(function (item) { return item.key === sort.key; });
            var sortExists = sortIndex >= 0;
            if (sortExists) {
                return;
            }
            _this.setState(function (prevState) { return ({
                sorts: __spreadArray(__spreadArray([], prevState.sorts), [sort])
            }); });
        };
        _this.toggleSort = function (key) {
            var sortIndex = _this.state.sorts.findIndex(function (item) { return item.key === key; });
            var sortExists = sortIndex >= 0;
            _this.setState(function (prevState) { return ({
                sorts: sortExists
                    ? prevState.sorts.map(function (sort, i) {
                        return i === sortIndex
                            ? {
                                key: key,
                                direction: _this.state.sorts[sortIndex].direction === 'ASC'
                                    ? 'DESC'
                                    : 'ASC'
                            }
                            : sort;
                    })
                    : __spreadArray(__spreadArray([], prevState.sorts), [
                        {
                            key: key,
                            direction: 'DESC'
                        }
                    ])
            }); });
        };
        _this.removeSort = function (key) {
            _this.setState(function (prevState) { return ({
                sorts: prevState.sorts.filter(function (sort) { return sort.key !== key; })
            }); });
        };
        _this.clearSorts = function () {
            _this.setState({
                sorts: []
            });
        };
        _this.addFilter = function (filter) {
            var valueExists = function (values, valueToMatch) {
                var indexMatch;
                if (Array.isArray(values)) {
                    indexMatch = values.findIndex(function (filterValue) {
                        return filterValue == valueToMatch;
                    });
                    return indexMatch >= 0 ? true : false;
                }
                else {
                    return values == valueToMatch;
                }
            };
            var filterIndex = _this.state.filters.findIndex(function (item) { return item.key === filter.key && valueExists(item.value, filter.value); });
            var filterExists = filterIndex >= 0;
            // This will set the table back to page 1 on a new filter
            _this.setState({ page: 1 });
            _this.setState(function (prevState) {
                return {
                    filters: filterExists
                        ? _this.removeExistingFilter(prevState.filters, {
                            key: filter.key,
                            value: Array.of(filter.value.toString())
                        })
                        : _this.addToExistingFilters(prevState.filters, {
                            key: filter.key,
                            value: Array.of(filter.value.toString())
                        })
                };
            });
        };
        _this.removeExistingFilter = function (existingFilters, filter) {
            var indexMatch = _this.returnMatchingIndex(existingFilters, filter, 'key');
            var filterMatching = existingFilters[indexMatch];
            var removeValue = Array.of(filter.value.toString());
            var existingValues = Array.isArray(filterMatching.value)
                ? filterMatching.value
                : Array.of(filterMatching.value);
            existingValues.map(function (val) { return val.toString(); });
            var newValues = lodash_1.xor(existingValues, removeValue);
            console.log('New Values: ', newValues);
            if (newValues.length === 0) {
                return [];
            }
            var newFilters = __spreadArray([], existingFilters);
            newFilters[indexMatch] = Object.assign({}, {
                key: filterMatching.key,
                value: newValues
            });
            console.log('New Filters: ', newFilters);
            return newFilters;
        };
        _this.addToExistingFilters = function (existingFilters, filter) {
            var indexMatch = existingFilters.findIndex(function (efilter) { return efilter.key === filter.key; });
            if (indexMatch < 0) {
                return __spreadArray(__spreadArray([], existingFilters), [filter]);
            }
            else {
                var matchingFilterValues = existingFilters[indexMatch].value;
                var newFiltersValues = Array.isArray(matchingFilterValues)
                    ? __spreadArray(__spreadArray([], matchingFilterValues), [filter.value.toString()]) : Array.of(matchingFilterValues, filter.value);
                var newFilters = __spreadArray([], existingFilters);
                newFilters[indexMatch] = Object.assign({}, existingFilters[indexMatch]);
                newFilters[indexMatch].value = newFiltersValues;
                return __spreadArray([], newFilters);
            }
        };
        _this.removeFilter = function (key) {
            _this.setState(function (prevState) { return ({
                filters: prevState.filters.filter(function (filter) { return filter.key !== key; })
            }); });
        };
        _this.clearFilters = function () {
            _this.setState({
                filters: []
            });
        };
        _this.selectItem = function (id) {
            if (!_this.props.selecting) {
                console.warn('You are attempting to select an item whilst selecting behaviour is disabled');
            }
            if (_this.state.items.find(function (item) { return id === item.id; })) {
                _this.setState(function (prevState) { return ({
                    selected: __spreadArray(__spreadArray([], prevState.selected), [id])
                }); });
            }
        };
        _this.deselectItem = function (id) {
            _this.setState(function (prevState) { return ({
                selected: prevState.selected.filter(function (selected) { return selected !== id; })
            }); });
        };
        _this.toggleSelectItem = function (id) {
            _this.state.selected.includes(id)
                ? _this.deselectItem(id)
                : _this.selectItem(id);
        };
        _this.selectAll = function () {
            _this.setState(function (prevState) { return ({
                selected: prevState.items.map(function (item) { return item.id; })
            }); });
        };
        _this.deselectAll = function () {
            _this.setState({
                selected: []
            });
        };
        _this.toggleSelectAll = function () {
            if (_this.allItemsAreSelected()) {
                _this.deselectAll();
            }
            else {
                _this.selectAll();
            }
        };
        _this.allItemsAreSelected = function () {
            return (_this.state.selected.length === _this.state.items.length &&
                _this.state.items.every(function (item) { return _this.state.selected.includes(item.id); }));
        };
        _this.generateProps = function () {
            return {
                listerSearch: _this.listerSearch,
                gotoPage: _this.gotoPage,
                search: _this.state.search,
                searchFields: _this.state.searchFields,
                overallCount: _this.state.overallCount,
                state: _this.state,
                reset: _this.resetState,
                permissions: {
                    canNavigateForwards: _this.state.page < _this.state.lastPage,
                    canNavigateBackwards: _this.state.page > 1
                },
                navigate: {
                    forwards: _this.navigateForwards,
                    backwards: _this.navigateBackwards,
                    toPage: _this.navigateToPage
                },
                items: {
                    update: _this.updateItemsViaAPI,
                    allSelected: _this.allItemsAreSelected,
                    select: _this.selectItem,
                    deselect: _this.deselectItem,
                    toggle: _this.toggleSelectItem,
                    selectAll: _this.selectAll,
                    deselectAll: _this.deselectAll,
                    toggleAll: _this.toggleSelectAll
                },
                filters: {
                    clear: _this.clearFilters,
                    add: _this.addFilter,
                    remove: _this.removeFilter
                },
                sorts: {
                    clear: _this.clearSorts,
                    add: _this.toggleSort,
                    remove: _this.removeSort,
                    toggle: _this.toggleSort
                }
            };
        };
        _this.listerSearch = function (searchItem) {
            if (_this.state.typingTimeout) {
                clearTimeout(_this.state.typingTimeout);
            }
            _this.setState({
                page: 1,
                searchItem: searchItem.target.value,
                typingTimeout: setTimeout(function () {
                    _this.updateItemsViaAPI();
                    _this.updateLocationViaState();
                }, 500) // delay sending request by 300ms - gives time to type
            });
        };
        /**
         * @param inclusions - An array of params to include when building the query string
         * @param includeFixedParams - Boolean value stating whether to include fixed params as part of the url (you likely want this for API requests but not the URL location)
         */
        _this.constructQueryStringFromState = function (inclusions, includeFixedParams) {
            if (includeFixedParams === void 0) { includeFixedParams = false; }
            var params = new URLSearchParams();
            if (inclusions.includes('search') && _this.state.searchItem.length > 0) {
                params.append('term', String(_this.state.searchItem));
            }
            if (inclusions.includes('page')) {
                params.append('page', String(_this.state.page || 1));
            }
            if (inclusions.includes('size')) {
                params.append('size', String(_this.props.size));
            }
            if (_this.state.sorts.length > 0 && inclusions.includes('sorts')) {
                if (_this.props.singleSort) {
                    if (_this.props.singleSort === true) {
                        var lastSort = void 0;
                        if (_this.state.sorts.length !== 1) {
                            lastSort = _this.state.sorts.pop();
                            _this.setState({ sorts: [lastSort] });
                        }
                        params.append('sort', _this.state.sorts[0].key + ":" + _this.state.sorts[0].direction);
                    }
                    else {
                        params.append('sort', _this.state.sorts
                            .map(function (_a) {
                            var key = _a.key, direction = _a.direction;
                            return key + ":" + direction;
                        })
                            .join());
                    }
                }
                else {
                    params.append('sort', _this.state.sorts
                        .map(function (_a) {
                        var key = _a.key, direction = _a.direction;
                        return key + ":" + direction;
                    })
                        .join());
                }
            }
            if (_this.state.filters.length > 0 && inclusions.includes('filters')) {
                params.append('where', _this.state.filters
                    .map(function (_a) {
                    var key = _a.key, value = _a.value;
                    return key + ":" + (Array.isArray(value) ? value.join('|') : value);
                })
                    .join());
            }
            if (_this.props.fixedParams && includeFixedParams) {
                _this.props.fixedParams.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    params.append(key, value);
                });
            }
            var queryString = decodeURIComponent(params.toString());
            return queryString;
        };
        _this.updateLocationViaState = function () {
            var noParams = _this.props.urlParams.length === 0;
            if (noParams) {
                return;
            }
            var url = window.location.pathname + "?" + _this.constructQueryStringFromState(_this.props.urlParams, false);
            if (url !== window.location.pathname + window.location.search) {
                window.history.pushState(null, null, url);
            }
        };
        _this.returnMatchingIndex = function (array, filter, key) {
            return array.findIndex(function (idv) { return idv[key] === filter[key]; });
        };
        _this.updateItemsViaAPI = _this.updateItemsViaAPI.bind(_this);
        _this.updateStateFromURL = _this.updateStateFromURL.bind(_this);
        window.onpopstate = function () {
            _this.updateStateFromURL();
        };
        return _this;
    }
    Lister.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.cacheCacheableResources();
                        if (!window.location.search) return [3 /*break*/, 1];
                        // Update params from URL will cause CDU, thus fetching the items
                        this.updateStateFromURL();
                        return [3 /*break*/, 3];
                    case 1:
                        this.navigateToPage(1);
                        return [4 /*yield*/, this.updateItemsViaAPI()];
                    case 2:
                        _a.sent();
                        this.updateLocationViaState();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Lister.prototype.componentDidUpdate = function (prevProps, prevState) {
        return __awaiter(this, void 0, void 0, function () {
            var pageHasChanged, navigatedForwards, sortHasChanged, filterHasChanged, searchItemHasChanged;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pageHasChanged = prevState.page !== this.state.page;
                        navigatedForwards = this.state.page === prevState.page + 1;
                        sortHasChanged = !lodash_isequal_1.default(prevState.sorts, this.state.sorts);
                        filterHasChanged = !lodash_isequal_1.default(prevState.filters, this.state.filters);
                        searchItemHasChanged = !lodash_isequal_1.default(prevState.searchItem, this.state.searchItem) &&
                            this.state.searchItem === '';
                        console.log('Previous Filters: ', prevState.filters);
                        if (!(pageHasChanged ||
                            sortHasChanged ||
                            filterHasChanged ||
                            searchItemHasChanged)) return [3 /*break*/, 2];
                        this.updateLocationViaState();
                        return [4 /*yield*/, this.updateItemsViaAPI(navigatedForwards)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Lister.prototype.updateItemsViaAPI = function (navigatedForwards) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, endpoint, headers, resource, _b, method, _c, body, requestParams, requestUrl, response, data;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props.api, url = _a.url, endpoint = _a.endpoint, headers = _a.headers, resource = _a.resource, _b = _a.method, method = _b === void 0 ? 'GET' : _b, _c = _a.body, body = _c === void 0 ? null : _c;
                        requestParams = __spreadArray([
                            'page',
                            'sorts',
                            'filters',
                            'search'
                        ], (this.props.size ? ['size'] : []));
                        requestUrl = "" + url + endpoint + "?" + this.constructQueryStringFromState(requestParams, true);
                        return [4 /*yield*/, fetch(requestUrl, {
                                headers: headers,
                                method: method,
                                body: body
                            })];
                    case 1:
                        response = _d.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _d.sent();
                        this.setState(function (prevState) {
                            var lastPage = data.pages.last;
                            var items = _this.props.behaviour === 'append' && navigatedForwards
                                ? __spreadArray(__spreadArray([], prevState.items), data[resource].filter(function (item) { return !prevState.items.find(function (x) { return x.id === item.id; }); })) : data[resource];
                            var selected = _this.props.behaviour === 'replace' ? [] : prevState.selected;
                            var searchFields = data.search_fields;
                            var overallCount = Number(data.overall_count);
                            return __assign(__assign({}, prevState), { lastPage: lastPage, items: items, selected: selected, searchFields: searchFields, overallCount: overallCount });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Lister.prototype.render = function () {
        if (this.props.children && this.props.render) {
            console.warn('Both a render prop and function as a child have been passed!\nBecause of this nothing will be rendered.');
        }
        return (React.createElement(ErrorBoundary_1.default, null, this.props.children && this.props.render
            ? null
            : this.props.children && !this.props.render
                ? this.props.children(this.generateProps())
                : !this.props.children && this.props.render
                    ? this.props.render(this.generateProps())
                    : null));
    };
    Lister.prototype.updateStateFromURL = function () {
        var params = new URLSearchParams(window.location.search);
        var page = Number(params.get('page')) >= 1 ? Number(params.get('page')) : 1;
        var sorts = params.get('sort')
            ? params
                .get('sort')
                .split(',')
                .map(function (sort) {
                var _a = sort.split(':'), key = _a[0], direction = _a[1];
                return { key: key, direction: direction };
            })
            : [];
        var filters = params.get('where')
            ? params
                .get('where')
                .split(',')
                .map(function (whereFilter) {
                var _a = whereFilter.split(':'), key = _a[0], value = _a[1];
                return { key: key, value: value.split('|') };
            })
            : [];
        console.log("Hello there");
        this.navigateToPage(page);
        this.setState({
            sorts: sorts,
            filters: filters
        });
    };
    Lister.prototype.cacheCacheableResources = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, headers, items, cache;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.cacheableResources) {
                            return [2 /*return*/];
                        }
                        _a = this.props.api, url = _a.url, headers = _a.headers;
                        return [4 /*yield*/, Promise.all(this.props.cacheableResources.map(function (_a) {
                                var resource = _a.resource, endpoint = _a.endpoint;
                                return fetch("" + url + endpoint, { headers: headers })
                                    .then(function (res) { return res.json(); })
                                    .then(function (res) {
                                    var _a;
                                    return (_a = {}, _a[resource] = res[resource], _a);
                                });
                            }))];
                    case 1:
                        items = _b.sent();
                        cache = items.reduce(function (acc, cv) { return (__assign(__assign({}, acc), cv)); }, {});
                        this.setState({ cache: cache });
                        return [2 /*return*/];
                }
            });
        });
    };
    Lister.defaultProps = {
        behaviour: 'replace',
        selecting: true,
        urlParams: []
    };
    return Lister;
}(React.Component));
exports.default = Lister;
